/* import __COLOCATED_TEMPLATE__ from './uninstall-button.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { task } from 'ember-concurrency';
import { HIDE_REINSTALL_APP_PACKAGE_IDS } from '../app-package';

export default Component.extend({
  intl: service(),
  appService: service(),
  store: service(),
  showUninstallModal: false,
  showReinstallModal: false,
  showExternalUninstallModal: false,
  subscriptionsPresent: false,

  showReinstallButton: computed('appPackage.id', function () {
    return !HIDE_REINSTALL_APP_PACKAGE_IDS.includes(this.appPackage?.id);
  }),

  init() {
    this._super(...arguments);
    if (this.showReinstallButton) {
      this.set('groupList', [
        {
          items: [
            {
              text: this.intl.t('appstore.app-package.uninstall-reinstall.reinstall'),
              value: 'reinstall',
            },
          ],
        },
      ]);
    } else {
      this.set('groupList', []);
    }
    this.fetchStripeSettings.perform();
  },

  fetchStripeSettings: task(function* () {
    if (this.appPackage?.implementationIdentifier !== 'stripe') {
      return;
    }
    try {
      let settings = yield this.store.queryRecord('appstore/app-package/stripe/app-settings', {});
      this.set('subscriptionsPresent', settings.subscriptions?.length > 0);
    } catch {
      // If settings can't be fetched, subscriptionsPresent stays false
    }
  }).drop(),

  groupList: [],
});
